import { ref, toRef, watch } from 'vue';
import { useAnimatedCount } from '../../composables/useAnimatedCount.js';

export default (props, { emit }) => {
  const localSelected = ref(props.selected);
  const initialCountWasPositive = ref(props.count > 0);

  // Track whether the count was ever positive, so the switch stays visible once
  // it has appeared. This gates the switch, not the number, so it stays here.
  watch(() => props.count, (newCount) => {
    if (newCount > 0) {
      initialCountWasPositive.value = true;
    }
  }, { immediate: true });

  // Variant B: every change animates, starting from the displayed value
  const { displayCount } = useAnimatedCount(toRef(props, 'count'), {
    skipFirstChange: false,
    from: 'display'
  });

  watch(() => props.selected, (newValue) => {
    localSelected.value = newValue;
  });

  const handleSwitchChange = () => {
    emit('update:selected', localSelected.value);
    emit('filterChange', {
      id: props.identifier,
      selected: localSelected.value
    });
  };

  return {
    localSelected,
    initialCountWasPositive,
    displayCount,
    handleSwitchChange,
  };
};
